import { css, flex, Button, Container } from "@balabalabom/ui";
import { useNavigate, useLocation } from "react-router-dom";
import { isMiniBookEnabled } from "../lib/featureFlags";
import { getStoreBaseUrl, shouldRedirectHomeToStore } from "../lib/storeUrls";

type NavItemProps = {
  label: string;
  active: boolean;
  onClick: () => void;
};

function navButtonStyle(active: boolean) {
  return active
    ? css({
        backgroundColor: "#e89b5f",
        borderRadius: "9999px",
        "&:hover": {
          backgroundColor: "#d88a4f",
          transform: "scale(1.05)",
          transition: "all 0.2s ease",
        },
      })
    : css({
        background: "transparent",
        border: "none",
        color: "white",
        fontSize: "0.9rem",
        fontWeight: "500",
        cursor: "pointer",
        padding: "0.5rem 1rem",
        borderRadius: "9999px",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.15)",
          textDecoration: "underline",
          transform: "translateY(-1px)",
          fontWeight: "600",
        },
        "@media (min-width: 768px)": {
          fontSize: "1rem",
        },
      });
}

function NavItem({ label, active, onClick }: NavItemProps) {
  if (active) {
    return (
      <Button
        onClick={onClick}
        variant="primary"
        size="sm"
        style={navButtonStyle(true)}
      >
        {label}
      </Button>
    );
  }
  return (
    <button type="button" onClick={onClick} style={navButtonStyle(false)}>
      {label}
    </button>
  );
}

export function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const storeHome = getStoreBaseUrl();

  const kidsHomePath = shouldRedirectHomeToStore() ? "/stories" : "/";
  const isStories =
    location.pathname === "/" ||
    location.pathname === "/stories" ||
    location.pathname.startsWith("/story/");
  const isEvents =
    location.pathname === "/events" || location.pathname.startsWith("/event/");
  const isAbout = location.pathname === "/about";
  const isMiniBook =
    location.pathname === "/minibook" ||
    location.pathname.startsWith("/minibook/");

  return (
    <header
      className="header-mobile"
      style={css({
        background: "linear-gradient(to right, #d97a5a, #f4c563, #b8c77a)",
      })}
    >
      <Container>
        <div className="header-content-mobile">
          <div
            style={{
              ...flex({ align: "center", gap: "0.75rem" }),
              cursor: "pointer",
            }}
            onClick={() => navigate(kidsHomePath)}
          >
            <img
              src="https://ik.imagekit.io/balabalabom/store/logo.png"
              alt="Balabalabom"
              className="logo-mobile"
            />
            <div style={flex({ direction: "column", gap: "0.25rem" })}>
              <h1 className="header-title-mobile">
                Balabalabom
                <br />
                KIDS
              </h1>
              <p className="header-subtitle-mobile">Stories &amp; Events</p>
            </div>
          </div>
          <div style={flex({ gap: "0.75rem", align: "center", wrap: "wrap" })}>
            {storeHome && (
              <a href={storeHome} style={navButtonStyle(false)}>
                Shop
              </a>
            )}
            <NavItem
              label="Events"
              active={isEvents}
              onClick={() => navigate("/events")}
            />
            <NavItem
              label="Stories"
              active={isStories}
              onClick={() => navigate("/stories")}
            />
            {isMiniBookEnabled && (
              <NavItem
                label="Mini-Book"
                active={isMiniBook}
                onClick={() => navigate("/minibook")}
              />
            )}
            <NavItem
              label="About"
              active={isAbout}
              onClick={() => navigate("/about")}
            />
          </div>
        </div>
      </Container>
    </header>
  );
}
